module.exports = require('../dist/components/CenteredContainer/CenteredContainer');
